import styled from "styled-components";
import { colors } from "../../../styles/colors";

export const StyledJoinLinkItem = styled.div`
  padding: 10px 0 15px;
  border-bottom: 1px solid ${colors.lightBlueGray};

  .join-link-item-name {
    font-size: 14px;
    color: ${colors.darkBlue};
  }

  .join-link-item-text-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 30px;

    .join-link-item-text {
      font-size: 12px;
      line-height: 14px;
      color: ${colors.blueGray};
    }
  }

  .join-link-urls-container {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .join-link-url {
      display: flex;
      flex-direction: column;
      gap: 4px;

      .url-label {
        font-size: 11px;
        font-weight: 600;
        color: ${colors.darkBlue};
      }

      .url-text {
        font-size: 12px;
        color: ${colors.blueGray};
        word-break: break-all;
        padding: 6px 8px;
        background-color: ${colors.lightBlueGray}20;
        border-radius: 4px;
        border: 1px solid ${colors.lightBlueGray};
      }

      &.long-url .url-text {
        border-color: #007aff;
        background-color: rgba(0, 122, 255, 0.05);
      }

      &.short-url .url-text {
        border-color: #34c759;
        background-color: rgba(52, 199, 89, 0.05);
      }
    }
  }
`;
